// src/config.js
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const SOCIAL_FRONTEND_URL = process.env.REACT_APP_SOCIAL_FRONTEND_URL;

// Google OAuth Client ID
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// Facebook App ID
export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;